import '@babel/polyfill';

import 'jquery';
import 'angular';
import 'lodash';
import 'mobile-detect';
import 'ng-device-detector';
import 'angular-segment-analytics';
import 'socket.io-client/dist/socket.io.js';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import './app.less';

import staffConfig from './staff.config';
import config from './app.config';
import run from './app.run';
import contactModalsTemplate from './pages/contact-us/contact-modals.html';

// controllers
import IndexController from './pages/index/index.controller';
import SignupController from './pages/signup/signup.controller';
import ContactController from './pages/contact-us/contact.controller';
import PricingController from './pages/pricing/pricing.controller';
import ActivateController from './pages/activate/activate.controller';
import ResellersController from './pages/resellers/resellers.controller';

// services
import ApiService from './services/api.service.js';
import contactService from './services/contact.service.js';
import socketService from './services/socket.service.js';
import downloadUrlsService from './services/download-urls.service.js';
import AnalyticsService from './services/analytics.service';

// components
import MobileErrorComponent from './components/mobile-error/mobile-error.component';

angular.module(
  'staffMain',
  [
    staffConfig,
    'ngSegment',
    'ng.deviceDetector',
  ])
  .config(config)
  .run(run)

  // controllers
  .controller('IndexController', IndexController)
  .controller('SignupController', SignupController)
  .controller('ContactController', ContactController)
  .controller('PricingController', PricingController)
  .controller('ActivateController', ActivateController)
  .controller('ResellersController', ResellersController)

  // components
  .component('mobileError', MobileErrorComponent)

  // services
  .factory('apiService', ApiService.factory)
  .factory('contactService', contactService.factory)
  .factory('socketService', socketService.factory)
  .factory('downloadUrlsService', downloadUrlsService.factory)
  .factory('analyticsService', AnalyticsService.factory)
  // see https://www.atatus.com/docs/javascript-frameworks/angular
  .factory('errorHttpInterceptor', ($q, $window) => {
    'ngInject';
    return {
      responseError: rejection => {
        if ($window.atatus) {
          const message = `AJAX Error: ${rejection.config.method} ` +
            `${rejection.status} ${rejection.config.url}`;
          atatus.notify(new Error(message), {
            config: rejection.config,
            status: rejection.status,
          });
        }
        return $q.reject(rejection);
      },
    };
  })
  .run(['$templateCache', function($templateCache) {
      var url = 'app/pages/contact-us/contact-modals.html';
      $templateCache.put(url, contactModalsTemplate);
  }]);
;
